<template>
  <section>
    <qx-search-box
        class="searchBox"
        ref="searchBox"
        :searchBoxData="searchBoxData"
        @sub="sub"
        title="筛选"
        permpisionsQuery=""
        :customSub="true"
    />
    <TableBox ref="tableBox" />
    <SubBtnBox
        :customPosifix="false"
        :cancelTextName="'返回'"
        :comfirmBtnHide="true"
    ></SubBtnBox>
  </section>
</template>

<script>
import TableBox from './tableBox';
import SubBtnBox from 'components/subBtnBox';
export default {
  components: {
    TableBox,
    SubBtnBox,
  },
  data () {
    return {
      searchBoxData: {
        form: [
          {
            label: '路径名称',
            value: 'pathName',
            type: 'input',
            placeholder: '请输入路径名称',
            default: this.$route.query.pathName ? decodeURIComponent(this.$route.query.pathName) : '',
          },
          {
            label: '车牌号',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号',
          },
          {
            label: '偏移开始时间',
            value: 'DependTime',
            type: 'date',
            placeholder: '请选择偏移开始时间',
            startPlaceholder: '开始时间',
            endPlaceholder: '结束时间',
            attr: {
              type: 'datetimerange',
            },
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      if (searchBoxData.DependTime && searchBoxData.DependTime.length > 0) {
        searchBoxData.startDate = this.formatDate(searchBoxData.DependTime[0], 1);
        searchBoxData.endDate = this.formatDate(searchBoxData.DependTime[1], 1);
      }
      delete searchBoxData.DependTime;
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
